import { Button } from 'antd';
import { formatTimestamp } from '@/features/report-history/utils/formatters';
import type { StudyReportVersion } from '../../../types/studyTimeline';
import { StatusBadge } from '../StatusBadge';
import { STATUS_CONFIG } from '../reportStatusConfig';
import styles from './ReportVersionRow.module.css';

interface ReportVersionRowProps {
  version: StudyReportVersion;
  onOpen: (uuid: string) => void;
}

export default function ReportVersionRow({
  version,
  onOpen,
}: ReportVersionRowProps) {
  const config = STATUS_CONFIG[version.status];

  return (
    <div className={styles.row}>
      {config ? (
        <StatusBadge variant={config.variant} label={config.label} />
      ) : (
        <StatusBadge variant="muted" label={version.status} />
      )}
      {version.isCurrent && <StatusBadge variant="primary" label="Current" />}
      <span className={styles.timestamp}>
        {formatTimestamp(version.timestamp)}
      </span>
      <span className={styles.author}>
        {[version.authorFirstName, version.authorLastName]
          .filter(Boolean)
          .join(' ')}
      </span>
      <Button
        type="link"
        size="small"
        className={styles.openBtn}
        onClick={() => onOpen(version.uuid)}
      >
        Open
      </Button>
    </div>
  );
}
